import React, { useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';
import s from './SalonFilter.module.scss';

const PriceRange = ({ setMaxPrice, maxPrice }) => {
    const [priceRange, setPriceRange] = useState(50);

    // Создаём мемоизированную debounced функцию
    const debouncedSetMaxPrice = useCallback(
        debounce((value) => {
            setMaxPrice(value);
        }, 300),
        [] // Мемоизация функции, чтобы она не создавалась заново при каждом рендере
    );

    const handleInputChange = (e) => {
        const value = Number(e.target.value);
        e.target.style.setProperty('--value', value);
        setPriceRange(value);
        debouncedSetMaxPrice(value); // Вызываем debounced функцию
    };

    // Очищаем debounce при размонтировании компонента
    useEffect(() => {
        return () => {
            debouncedSetMaxPrice.cancel();
        };
    }, [debouncedSetMaxPrice]);

    return (
        <div className={s.price_range_slider}>
            <div className={s.price_range_slider_container}>
                <span className={s.price_range_slider_container_value}>$10</span>
                <input
                    type="range"
                    min="10"
                    max="1000"
                    value={priceRange}
                    onInput={handleInputChange}
                    className={s.price_range_slider_container_slider}
                />
                <span className={s.price_range_slider_container_value}>${maxPrice}</span>
            </div>
        </div>
    );
};

export default PriceRange;
